'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { MAX_ITEMS_PER_LIST } from '@shared/utils/constants/pagination';
export const usePagination = t0 => {
  const $ = _c(4);
  const {
    initialPage: t1,
    pageCount: t2
  } = t0;
  const initialPage = t1 === undefined ? 1 : t1;
  const pageCount = t2 === undefined ? MAX_ITEMS_PER_LIST : t2;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const startIndex = (currentPage - 1) * pageCount;
  const endIndex = startIndex + pageCount;
  let t3;
  if ($[0] !== currentPage || $[1] !== endIndex || $[2] !== startIndex) {
    t3 = {
      currentPage,
      endIndex,
      setCurrentPage,
      startIndex
    };
    $[0] = currentPage;
    $[1] = endIndex;
    $[2] = startIndex;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};